export default __webpack_public_path__ + "static/media/six.1345fc84.jpeg";